import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { ROUTES } from './navbar-routes.config';
import { MenuType } from './navbar.metadata';
import { ICustomer } from '../Customer/customer.class';
import { CustomerService } from '../../services/customer.service';
import { Router } from '@angular/router';

@Component({
    moduleId: module.id,
    selector: 'navbar',
    templateUrl: 'navbar.component.html',
    styleUrls: ['navbar.component.css']
})

export class NavbarComponent implements OnInit
{
    public menuItems: any[];
    public brandMenu: any;
    isCollapsed = false;
    @Input() userName: string;
    @Output() menu = new EventEmitter<string>();

    constructor( private userService: CustomerService, private router: Router)
    {
    }

    login()
    {
        this.router.navigate(['login']);
    }

    logout()
    {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        this.router.navigate(['login']);
    }

    onCustomers()
    {
        this.menu.emit('customers');
    }

    onSystem()
    {
        this.menu.emit('system');
    }

    onHome()
    {
        this.menu.emit('home');
    }

    toggle()
    {
        this.isCollapsed = !this.isCollapsed;
    }

    ngOnInit()
    {
    }

    public get menuIcon(): string
    {
        return this.isCollapsed ? '☰' : '✖';
    }

    public getMenuItemClasses(menuItem: any)
    {
        return {
            'pull-xs-right': this.isCollapsed && menuItem.menuType === MenuType.RIGHT
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/components/navbar/navbar.component.ts